var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-loader-host"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"bar1"}),_vm._v(" "),_c('div',{staticClass:"bar2"}),_vm._v(" "),_c('div',{staticClass:"bar3"}),_vm._v(" "),_c('div',{staticClass:"bar4"}),_vm._v(" "),_c('div',{staticClass:"bar5"}),_vm._v(" "),_c('div',{staticClass:"bar6"})])])
}]

export { render, staticRenderFns }